import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";

savedOrderListTableStyles.subtotalCell = {
    alignX: "left",
};
